// @flow
const isPendingShowToJoin = (state: Object): boolean => state.leagues.show_to_join.is_pending;

export default isPendingShowToJoin;


// WEBPACK FOOTER //
// ./src/modules/selectors/league/isPendingShowToJoin.js